export default "<p>cookingtemp works!</p>\n"